// @ts-check
import axios from 'axios';

/** @typedef {import('axios').AxiosRequestConfig} AxiosRequestConfig */
/** @typedef {import('./schema').operations} Operations */
/** @typedef {Operations['care_management_list_programs']['responses'][200]['content']['application/json']} CareManagementProgram[] */

/**
 * List care-management programs configured for the current tenant.
 *
 * @param {AxiosRequestConfig} [config]
 * @returns {Promise<CareManagementProgram[]>}
 */
export async function listCareManagementPrograms(config) {
  const { data } = await axios.get('/api/care-management/programs/', config);
  return data;
}
